var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-10 radius-10 fill-height",style:('border-top: 5px solid ' + _vm.color)},[_c('v-card-text',{staticClass:"pa-6 grey--text text--darken-2"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }